import { WoBaseModel } from './wo-base-model';

export class ExportRegular extends WoBaseModel {
  vessel = '';
  overHeight = false;
  overWeight = false;
  haz = false;
  houseBillOfLading = '';
  poNumber = '';
  containerNumber = '';
  containerSize = '40ST';
  containerType = 'DRY';
  erd = '';
  cutOff = '';
  freeDays = null;
  freeDaysType = 'Calendar';
  seal = '';
  commodity = '';
  quantity = null;
  unit = 'Unit';
  shippingLine = '';
  pulloutChassisNumber = '';
  chassisNumber = '';
  chassisPool = '';
  bondEntry = '';
  cf = '';
  dropLive = 'DROP';
  bookingNumber = '';
  wms = false;
  tare = '';
  streetTurn = '';
  returnFreeDay = '';
}
